<template>
  <div
    class="backWrap"
    :style="{ backgroundColor: componentData[0].style.backgroundColor }"
  >
    <img
      v-if="getBackSrc"
      :src="getBackSrc"
      class="curPageBackgroundPic"
      :class="isFillBg ? 'bg-fill' : 'bg-contain'"
    />

    <svg
      class="grid"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      v-if="isGridValid"
    >
      <defs>
        <pattern
          id="smallGrid"
          width="7.236328125"
          height="7.236328125"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M 7.236328125 0 L 0 0 0 7.236328125"
            fill="none"
            stroke="rgba(207, 207, 207, 0.3)"
            stroke-width="1"
          ></path>
        </pattern>
        <pattern
          id="grid"
          width="36.181640625"
          height="36.181640625"
          patternUnits="userSpaceOnUse"
        >
          <rect
            width="36.181640625"
            height="36.181640625"
            fill="url(#smallGrid)"
          ></rect>
          <path
            d="M 36.181640625 0 L 0 0 0 36.181640625"
            fill="none"
            stroke="rgba(186, 186, 186, 0.5)"
            stroke-width="1"
          ></path>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)"></rect>
    </svg>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getPicSrc } from "@/utils/utils";
import { isBackBackgroundFill } from "@/utils/backBackgroundSize";
export default {
  computed: {
    ...mapState(["componentData"]),
    getBackSrc() {
      return getPicSrc(this.componentData[0]?.style?.backPicSrc);
    },
    isGridValid() {
      return this.componentData[0]?.style?.grid;
    },
    isFillBg() {
      return isBackBackgroundFill(this.componentData[0]?.style?.backgroundSize);
    },
  },
};
</script>
<style lang="scss" scoped>
.backWrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.grid {
  position: absolute;
  top: 0;
  left: 0;
}
.curPageBackgroundPic {
  display: block;
}
/* contain 字段 = 铺满：拉伸填满画布 */
.bg-fill {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
/* 100% 100% 字段 = 等比例：完整显示，居中留边 */
.bg-contain {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}
</style>
